import { Stepper as StepperProvider } from '@/components/Stepper'

import { useStepper } from '../Stepper/StepperContext'

import SimulationContainer from './components/SimulationContainer'
import { SimulationForm } from './components/SimulationForm'
import { SimulationResult } from './components/SimulationResult'
import { FgtsLoanSimulatorProvider } from './core/provider'
import { SIMULATION_FORM_STEP } from './core/utils'

export const SIMULATION_COMPONENTS = {
  simulationForm: SimulationForm,
  simulationResult: SimulationResult,
}

const ActiveSimulationComponent = (): JSX.Element => {
  const { ActiveComponent } = useStepper()
  return <ActiveComponent />
}

const FgtsLoanSimulator = ({ url }: { url: string }) => (
  <StepperProvider components={SIMULATION_COMPONENTS} initialStep={SIMULATION_FORM_STEP}>
    <FgtsLoanSimulatorProvider ctaHref={url}>
      <SimulationContainer>
        <ActiveSimulationComponent />
      </SimulationContainer>
    </FgtsLoanSimulatorProvider>
  </StepperProvider>
)
export default FgtsLoanSimulator
